import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { ICreateUnitMeasure } from '../interfaces/create-unit-measure.interface';
import AlternalUnitMeasurementAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity';
import { UnitMeasureService } from 'app/modules/components/master/unit-of-measurement/unit-of-measurement.service';
import UnitMeasurementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { TwoDecimalPipe } from '../../../../../pipes/decimal.pipe';
import { MaterialUnitMeasureService } from '../material-unit-alternate.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';

@Component({
  selector: "app-add-material-unit-modal",
  styleUrl: "./material-alternate-unit.scss",
  templateUrl: "./material-alternate-unit.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggle,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatCheckboxModule,
    TwoDecimalPipe,
  ],
})
export class AddMaterialUnit {
  currentCreateUnit: ICreateUnitMeasure = this.initializeCreateUnit();
  baseUnitOfMeasuresList: UnitMeasurementsAttributes[] = [];
  existUnitOfMeasuresList: AlternalUnitMeasurementAttributes[] = [];
  isEditMode: boolean;
  currentUpdateMaterialUnit: AlternalUnitMeasurementAttributes | undefined;
  isDuplicate: boolean = false;
  nameUnitOfMeasure: string;
  unitPName: string;
  companyList: CompanyAttributes[] = [];
  decimalsAllowed: number;
  decimalsAllowedDisplay: number;

  constructor(
    public dialogRef: MatDialogRef<AddMaterialUnit>,
    private baseunitService: UnitMeasureService,
    private companyService: CompanyService,
    private unitService: MaterialUnitMeasureService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.nameUnitOfMeasure = data.material.baseUnitOfMeasure?.name;
    this.isEditMode = !!data.existingData;
    if (this.isEditMode) {
      this.currentCreateUnit = {
        ...data.existingData,
        unitMeasureId: data.existingData.unitOfMeasure._id.toString(),
        // buOfMsave: data.existingData.baseUnitOfMeasure.name,
      };
      this.unitPName = data.existingData.unitOfMeasure.name;
    }
  }

  ngAfterViewInit(): void {
    this.unitService
      .findByMaterialId(this.data.material._id.toString())
      .subscribe((data) => {
        this.existUnitOfMeasuresList = data.data;
      });
    this.fetchunitBaseOfMeasurement();
    this.getCompanies();
  }

  private getCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
      this.decimalsAllowed = this.companyList[0].stockDecimalsWork;
      this.decimalsAllowedDisplay = this.companyList[0].stockDecimalsDisplay;
    });
  }

  onUnitMeasureChange(selectedId: string) {
    const selected = this.baseUnitOfMeasuresList.find(
      (u) => u._id.toString() === selectedId
    );
    this.unitPName = selected?.name ?? "";

    this.checkDuplicate();
  }

  checkDuplicate() {
    this.isDuplicate = this.existUnitOfMeasuresList.some(
      (unit) =>
        unit.unitOfMeasure._id.toString() ===
        this.currentCreateUnit.unitMeasureId
    );

    if (this.isDuplicate) {
      this.unitPName =
        this.existUnitOfMeasuresList.find(
          (unit) =>
            unit.unitOfMeasure._id.toString() ===
            this.currentCreateUnit.unitMeasureId
        )?.unitOfMeasure.name || this.unitPName;

      this.snackBar.open("Esta unidad de medida ya existe", "Cerrar", {
        duration: 5000,
      });
    }
  }

  private fetchunitBaseOfMeasurement(): void {
    this.baseunitService.findToComboBox().subscribe((res) => {
      this.baseUnitOfMeasuresList = res.data;
    });
  }

  private initializeCreateUnit(): ICreateUnitMeasure {
    return {
      quantity: 0,
      equivalentQuantity: 0,
      unitMeasureId: "",
      conversionFactor: 0,
      barcode: "",
      isCommercialUom: false,
      isUMB: false,
      isUMP: false,
    };
  }

  onCheckboxChange(checkboxName: "isCommerciaUom" | "isUMP"): void {
    if (checkboxName === "isCommerciaUom") {
      this.currentCreateUnit.isUMP = !this.currentCreateUnit.isCommercialUom;
    } else if (checkboxName === "isUMP") {
      this.currentCreateUnit.isCommercialUom = !this.currentCreateUnit.isUMP;
    }
  }

  /** Base-UoM units per alternative-UoM unit: equivalentQuantity (base) / quantity (alternative). */
  get conversionFactor(): number {
    const q = this.currentCreateUnit.quantity;
    const eq = this.currentCreateUnit.equivalentQuantity;

    if (!eq || !q || q === 0) return NaN;

    return eq / q;
  }

  get isConversionFactorInvalid(): boolean {
    return isNaN(this.conversionFactor) || !isFinite(this.conversionFactor);
  }

  get conversionFactorDisplay(): string {
    return this.conversionFactor.toFixed(this.decimalsAllowedDisplay);
  }

  save() {
    this.currentCreateUnit.conversionFactor = this.currentCreateUnit.quantity
      ? Number(
          (
            this.currentCreateUnit.equivalentQuantity /
            this.currentCreateUnit.quantity
          ).toFixed(this.decimalsAllowed)
        )
      : 0;

    const dataToSend = Object.entries(this.currentCreateUnit).reduce(
      (acc, [key, value]) => {
        if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
          acc[key] = value;
        }
        return acc;
      },
      {}
    );
    this.dialogRef.close(dataToSend);
  }
}
